exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#payment-methods[data-v-05f49c22]{margin-top:80px}.page-title[data-v-05f49c22]{margin-bottom:20px}.table th[data-v-05f49c22]{border-top:none}.badge[data-v-05f49c22]{font-size:.75em}.btn-group .btn[data-v-05f49c22]{margin-right:2px}.btn-group .btn[data-v-05f49c22]:last-child{margin-right:0}", ""]);

// exports
